import CaptainBulkActionsAPI from 'dashboard/api/captain/bulkActions';
import { createStore } from '../storeFactory';
import { throwErrorMessage } from 'dashboard/store/utils/api';

const captureContext = context => {
  const key = () =>
    JSON.stringify([
      context.rootGetters?.getCurrentAccountId,
      context.rootState?.route?.params?.assistantId,
      context.rootState?.route?.fullPath,
    ]);
  const initial = key();
  return () => key() === initial;
};

export default createStore({
  name: 'CaptainBulkAction',
  API: CaptainBulkActionsAPI,
  mutations: {
    START_BULK_REQUEST(state) {
      state.requestId = (state.requestId || 0) + 1;
    },
  },
  actions: mutations => ({
    processBulkAction: async function processBulkAction(
      { commit, state },
      { type, actionType, ids }
    ) {
      commit('START_BULK_REQUEST');
      const requestId = state.requestId;
      commit(mutations.SET_UI_FLAG, { isUpdating: true });
      try {
        const response = await CaptainBulkActionsAPI.create({
          type: type,
          ids,
          fields: { status: actionType },
        });
        return response.data;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        if (state.requestId === requestId) {
          commit(mutations.SET_UI_FLAG, { isUpdating: false });
        }
      }
    },

    handleBulkDelete: async function handleBulkDelete(
      context,
      { type = 'AssistantResponse', ids }
    ) {
      const { dispatch } = context;
      const isCurrent = captureContext(context);
      const response = await dispatch('processBulkAction', {
        type,
        actionType: 'delete',
        ids,
      });

      if (!isCurrent()) return response;
      if (type === 'AssistantResponse') {
        // Update the response store after successful API call
        await dispatch('captainResponses/removeBulkResponses', ids, {
          root: true,
        });
      } else if (type === 'AssistantDocument') {
        await dispatch('captainDocuments/removeBulkRecords', ids, {
          root: true,
        });
      }
      return response;
    },

    handleBulkApprove: async function handleBulkApprove(context, ids) {
      const { dispatch } = context;
      const isCurrent = captureContext(context);
      const response = await dispatch('processBulkAction', {
        type: 'AssistantResponse',
        actionType: 'approve',
        ids,
      });

      if (!isCurrent()) return response;
      // Update response store after successful API call
      await dispatch('captainResponses/updateBulkResponses', response, {
        root: true,
      });
      return response;
    },

    handleBulkSync: async function handleBulkSync(context, { ids }) {
      const { dispatch } = context;
      const isCurrent = captureContext(context);
      const response = await dispatch('processBulkAction', {
        type: 'AssistantDocument',
        actionType: 'sync',
        ids,
      });

      if (!isCurrent()) return response;
      await dispatch('captainDocuments/markSyncing', response.ids || [], {
        root: true,
      });
      return response;
    },
  }),
});
